import {vpost} from "@/util/post";

export const user = {
    login: (username, password) => {
        let dto = {
            username,
            password
        }

        return vpost("/login/admin", dto);
    },

    listStaff: async (pageCurrent, pageSize, key) => {

        let formData = new FormData();
        formData.append("pageCurrent", pageCurrent);
        formData.append("pageSize", pageSize);
        formData.append("keyword", key);

        return (await vpost("/user/listStaff", formData));
    },

    logout: async () => {
        return (await vpost("/login/adminLogout")).data;
    },

    updateStaff(form) {
        return vpost("/user/updateStaff", form);
    },

    miuList(pageSize, pageCurrent, keyword) {
        let dto = {
            pageCurrent, pageSize, keyword
        }
        return vpost("/user/listMiu", dto);
    },

    customerList(pageSize, pageCurrent) {
        let dto = {
            pageCurrent, pageSize
        }
        return vpost("/user/listCustomer", dto);
    },

    /**
     * 获取待审核的记录
     * @returns {Promise}
     */
    listPendingCustomerExamine() {
        return vpost("/user/listPendingCustomerExamine");
    },

    /**
     * 营业执照审批
     * @param {String } id
     * @param {Boolean} examineFlag
     * @param {String} rejectedMsg
     * @returns {Promise}
     */
    examineCustomer(id, examineFlag, rejectedMsg) {
        return vpost("/user/examineCustomer", {id, examineFlag, rejectedMsg});
    },

    /**
     * 获取客户公司认证信息
     * @param userId
     * @returns {Promise}
     */
    getCusCompanyCertificationVO(userId) {
        return vpost("/user/getCusCompanyCertificationVO?userId=" + userId);
    },

    delCertification(userId) {
        return vpost("/user/delCertification?userId=" + userId);
    },

    /**
     * 获取所有团队
     * @returns {Promise}
     */
    listAllDealer() {
        return vpost("/user/listAllDealer");
    },

    /**
     * 搜索客户（远程搜索）
     * @param {string} keyword - 搜索关键字
     * @returns {Promise}
     */
    searchCustomer(keyword) {
        return vpost("/user/searchCustomer", {keyword});
    },
}
